import Translator from '../../classes/Translator/Translator';
const DmrvChartLogic = () => {
    const { translator } = Translator();

    return {
        translator,
    };
};
export default DmrvChartLogic;



